import { Disclosure } from '@headlessui/react';

import { CaretDownIcon } from '~components/icons/CaretDownIcon';
import { CaretUpIcon } from '~components/icons/CaretUpIcon';
import useLabels from '~hooks/useLabels';
import { Collection } from '~modules/media-library/model/Collection';
import { DetailListItem } from '~modules/media-library/view/CollectionDetail/DetailItem';

export function CollectionDetail({ collection }: { collection: Collection }) {
  const { labelMediaLibraryCollectionDescription, labelMediaLibraryCollectionCreator, labelMediaLibraryCollectionId } =
    useLabels([
      'labelMediaLibraryCollectionDescription',
      'labelMediaLibraryCollectionCreator',
      'labelMediaLibraryCollectionId',
    ]);

  return (
    <div className="ml--collection-detail">
      <Disclosure>
        {({ open }) => (
          <>
            <Disclosure.Button
              className={`appearance-none flex justify-between items-center border-none outline-none bg-transparent text-left rounded-md transition cursor-pointer`}
            >
              <span className="flex flex-col">
                <span className="font-sans font-bold text-lg">
                  <span dangerouslySetInnerHTML={{ __html: collection.title }} />
                </span>
              </span>
              <div className="w-8 h-8 p-1">{open ? <CaretUpIcon /> : <CaretDownIcon />}</div>
            </Disclosure.Button>
            <a href={collection.link} target="_blank" rel="noreferrer noopener" className="text-sm pl-2">
              {collection.link}
            </a>
            <Disclosure.Panel className="py-2">
              <div className="bg-gray">
                <DetailListItem label={labelMediaLibraryCollectionDescription}>{collection.description}</DetailListItem>
                <DetailListItem label={labelMediaLibraryCollectionCreator}>
                  {collection.responsiblePerson}
                </DetailListItem>
                <DetailListItem label={labelMediaLibraryCollectionId}>{collection.id}</DetailListItem>
              </div>
            </Disclosure.Panel>
          </>
        )}
      </Disclosure>
    </div>
  );
}
